// When emitting our html page (the entrypoint to our frontend code),
// fastly embeds some session-specific data in the html as a
// javascript variable.  This data is available for immediate use by
// our frontend code without needing to make an API call.  This is
// the file that gives access to this data.

// TODO(csilvers, INFRA-10172): remove all access to `__HEADERS__`,
// and support for reading `__HEADERS__`, once the fastly changes
// are live.

// sync-start:fastly-data-varname 702155918 ./libs/dev/page-template/src/make-page.ts
const FASTLY_DATA_VARNAME = "__KA_DATA__";
// sync-end:fastly-data-varname

function getBoolean(fieldname: string): boolean {
    if (globalThis[FASTLY_DATA_VARNAME] === undefined) {
        // This should be impossible, but just in case...
        throw new Error(`${FASTLY_DATA_VARNAME} not found!`);
    }
    return globalThis[FASTLY_DATA_VARNAME][fieldname];
}

function getString(fieldname: string): string {
    if (globalThis[FASTLY_DATA_VARNAME] === undefined) {
        // This should be impossible, but just in case...
        throw new Error(`${FASTLY_DATA_VARNAME} not found!`);
    }
    return globalThis[FASTLY_DATA_VARNAME][fieldname];
}

// The header names below should match _kaDataToEmbedInHTML in
// services/fastly-khanacademy-compute/handlers/webpage.go

// sync-start:headers 1788628070 ./libs/config/jest/src/setup-window-globals-for-testing.js
export function kaIsE2E(): boolean {
    return getBoolean("KA-is-e2e");
}

export function kaIsBot(): boolean {
    return getBoolean("KA-is-bot");
}

export function kaIsPhone(): boolean {
    return getBoolean("KA-is-phone");
}

export function kaIsTablet(): boolean {
    return getBoolean("KA-is-tablet");
}

export function kaIsUnsupportedBrowser(): boolean {
    return getBoolean("KA-is-unsupported-browser");
}

export function kaIsIOS(): boolean {
    return getBoolean("KA-is-ios");
}

export function kaIsMobileApp(): boolean {
    return getBoolean("KA-is-mobile-app");
}

export function kaFastlyCountry(): string {
    return getString("KA-fastly-country");
}

export function kaRegion(): string {
    return getString("KA-region");
}

export function kaLocale(): string {
    return getString("KA-locale");
}

export function kaLocaleStatus(): string {
    return getString("KA-locale-status");
}

export function kaCurriculum(): string {
    return getString("KA-curriculum");
}

export function kaHasAnyPermissions(): boolean {
    return getBoolean("KA-has-any-permissions");
}

export function kaIsPhantom(): boolean {
    return getBoolean("KA-is-phantom");
}

export function kaHasProfile(): boolean {
    return getBoolean("KA-has-profile");
}

export function kaStaticVersion(): string {
    return getString("KA-static-version");
}

export function kaPublishedContentVersion(): string {
    return getString("KA-published-content-version");
}
// sync-end:headers
